$.fn.wh_cookie_advice = function(options) {
	// Default settings
	var settings = $.extend({
		"cookie_name"		: "wh_cookie_accepted",		// Name of the cookie
		"cookie_expiration"	: 30, 						// Cookie expiration in days (30 days)
		"accept_button_id"	: "wh_cookie_advice_accept",// ID of the accept button
		"path"				: "/"
	}, options);
	// Show cookie advice
	if ($.cookie(settings.cookie_name) === undefined){
		this.fadeIn(1000);
		$('#wh_cookie_advice_accept').click(function(){
			$.cookie(settings.cookie_name, 'true', {path: settings.path, expires: settings.cookie_expiration});
			$(this).parent().parent().parent().parent().fadeOut(500);
			return false;
		});
	}
	return this;
};